module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.a6a07dc8.webp";